import request from "@/utils/request";

export function queryCustomerByFinance(data){
  return request({
    url:'/osp/org-company/queryCustomerByFinance',
    method:'post',
    data: data
  })
}

// export function  queryPayHistory(data){
//   return request({
//     url:'/osp/payRecord/queryPagePayHistory',
//     method:'post',
//     data:data
//   })
// }

// export function queryPayStatus(data){
//   return request({
//     url:'/osp/payQuery/queryAbcPayStatus',
//     method:'post',
//     data:data
//   })
// }
